import React from "react";

export const Rhea = () => {
  return (
    <div>
      <div
        id={"rhea"}
        style={{
          frameborder: "0",
          width: "100%",
          height: "470px",
        }}
      ></div>
    </div>
  );
};
